import React, { useEffect, useMemo, useRef, useState } from "react";
import { sanitizeHtml } from "../../utils/sanitizeHtml.js";
import "../../assets/styles/Request.css";

function HtmlNote({ html }) {
  const containerRef = useRef(null);
  const [copyMessage, setCopyMessage] = useState("");
  const safeHtml = useMemo(() => sanitizeHtml(html), [html]);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return undefined;
    const copyNodes = [...container.querySelectorAll("[data-copy-code]")];

    const copy = async (element) => {
      const value = element.textContent || "";
      try {
        await navigator.clipboard.writeText(value);
        setCopyMessage(`Đã sao chép: ${value}`);
      } catch (error) {
        setCopyMessage("Không thể sao chép nội dung.");
      }
    };
    const cleanups = copyNodes.map((element) => {
      element.classList.add("request-note-copy-code");
      element.setAttribute("role", "button");
      element.setAttribute("tabindex", "0");
      element.setAttribute("aria-label", `Sao chép ${element.textContent || ""}`);
      const onClick = () => copy(element);
      const onKeyDown = (event) => {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          copy(element);
        }
      };
      element.addEventListener("click", onClick);
      element.addEventListener("keydown", onKeyDown);
      return () => {
        element.removeEventListener("click", onClick);
        element.removeEventListener("keydown", onKeyDown);
      };
    });
    return () => cleanups.forEach((cleanup) => cleanup());
  }, [safeHtml]);

  return <div><div ref={containerRef} className="request-html-note" dangerouslySetInnerHTML={{ __html: safeHtml }} />{copyMessage && <p className="request-note-copy-message">{copyMessage}</p>}</div>;
}

export default HtmlNote;
